export default "__VITE_ASSET__DeQkpO0i__"